import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Table} from '..';
import {openModal} from '../../actions';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'name',
    numeric: false,
    disabledPadding: true,
    label: 'Entrance Name',
  },
  {
    id: 'buildingName',
    numeric: false,
    disabledPadding: false,
    label: 'Building',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = ['name', 'buildingName', 'createdAt'];

const EntrancesTable = ({entrances, loading, hideAddButton}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {buildingById} = useSelector(s => s.buildings);
  const tableOrder = useTableSort('asc', 'createdAt');
  const onRowClick = item => {
    navigate(`/entrances/${item}`);
  };
  const rowHref = item => `/entrances/${item}`;
  const onAddEntrance = () => {
    dispatch(openModal('AddEntranceModal', {buildingID: buildingById.id}));
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={entrances}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      onRowClick={onRowClick}
      rowHref={rowHref}
      onAdd={!hideAddButton ? onAddEntrance : null}
      noToolbar={hideAddButton}
      {...tableOrder}
    />
  );
};

export default EntrancesTable;
